import React from 'react';

/**
 * A custom icon for indicating wireless screenshare.
 *
 * @returns {ReactElement}
 */
export default function WirelessScreenshareIcon() {
    return <i className = 'material-icons'>wireless_screen_share</i>;
}
